const Trust = () => (
  <section id="trust" style={{ maxWidth: "1280px", margin: "0 auto", padding: "112px 24px", display: "flex", flexDirection: "column", gap: "40px" }}>
    <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center", textAlign: "center" }}>
      <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
        وثقوا بنا
      </span>
      <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
        ماذا يقول المعلّمون والمعلّمات ؟
      </h2>
    </div>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(360px, 100%), 1fr))", gap: "20px" }}>
      <figure style={{ margin: "0", background: "#141C63", color: "#FFFFFF", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px", gridColumn: "span 1" }}>
        <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#FFC93C" }}>
          ”
        </span>
        <blockquote style={{ margin: "0", fontSize: "18px", lineHeight: "1.9" }}>
          في زمن التكنولوجيا خطوتان ضروريتان، خطوة للمعرفة وخطوة للتكنولوجيا وذاك تطبيق خطوة.
        </blockquote>
        <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
          <strong>
            حبيبة الرايس
          </strong>
          <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
            مدرّسة العربيّة للمبتدئين
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
        <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#46D3BE" }}>
          ”
        </span>
        <blockquote style={{ margin: "0", fontSize: "17px", lineHeight: "1.9", color: "#2A3160" }}>
          المتعة والتعلم في رحلة فريدة لاستكشاف العالم بطريقة مشوقة ومسلية. هذا هو تطبيق خطوة، المبتكر التونسي الذي يجمع بين الألعاب والتعلم في آن واحد... لتعزيز المفاهيم التعليمية مع تقييم فردي وتقارير تطويرية هنيئا لكم.
        </blockquote>
        <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
          <strong>
            آية النّوي
          </strong>
          <span style={{ fontSize: "14px", color: "#4B5480" }}>
            أستاذة المدارس الابتدائية
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
        <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#46D3BE" }}>
          ”
        </span>
        <blockquote style={{ margin: "0", fontSize: "17px", lineHeight: "1.9", color: "#2A3160" }}>
          هي خطوة ثابتة للارتقاء بالمتعلم نحو التميّز وبناء معارفه على أسس صلبة والسموّ به نحو الأفضل والتعلم في جو من الاستمتاع اعتمادا على ما يقدّم له من تمارين تهدف إلى تجويد مكتسباته بطريقة رائعة تقوده إلى التفوّق.
        </blockquote>
        <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
          <strong>
            نجم الدين جرفال
          </strong>
          <span style={{ fontSize: "14px", color: "#4B5480" }}>
            أستاذ مدارس ابتدائيّة فوق الرّتبة مميّز متقاعد
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
        <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#46D3BE" }}>
          ”
        </span>
        <blockquote style={{ margin: "0", fontSize: "17px", lineHeight: "1.9", color: "#2A3160" }}>
          هي بمثابة كبسولات تربوية تعليمية حديثة ومبتكرة متطابقة مع البرامج الرسمية و تمس الذكاءات المميزة لكل متعلم وأنماط تعلمه. فهي تعالج الصعوبات و تنمي المهارات والقدرات للتلميذ مع سهولة في الاستعمال
        </blockquote>
        <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
          <strong>
            محمد زيراوي
          </strong>
          <span style={{ fontSize: "14px", color: "rgb(75, 84, 128)" }}>
            مدرس المعرفة للمدنيين
          </span>
        </figcaption>
      </figure>
      <figure style={{ margin: "0", background: "#FFC93C", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
        <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#0B1240" }}>
          ”
        </span>
        <blockquote style={{ margin: "0", fontSize: "20px", lineHeight: "1.8", fontWeight: "600", color: "#0B1240" }}>
          لكل بداية خطوة أولى. و تطبيق خطوة سيكون الخطوة الأولى نحو التميّز.
        </blockquote>
        <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto", color: "#0B1240" }}>
          <strong>
            سالمة الحبيبي
          </strong>
          <span style={{ fontSize: "14px" }}>
            أستاذ أول فوق الرتبة للمدارس الابتدائية
          </span>
        </figcaption>
      </figure>
      <div style={{ background: "#E2F7F3", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center", alignItems: "flex-start" }}>
        <span dir="ltr" style={{ fontFamily: "\"Baloo Bhaijaan 2\", sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "rgb(20, 94, 85)" }}>
          +2000
        </span>
        <span style={{ fontSize: "17px", color: "rgb(46, 74, 71)" }}>
          ولي نزّل تطبيق خطوة ...
        </span>
      </div>
    </div>
  </section>
);

export default Trust;
